export default __webpack_public_path__ + "static/media/Blue_star.a4f00640.svg";